var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7928V15.0858C0 15.2184 0.0526785 15.3456 0.146447 15.4393C0.240215 15.5331 0.367392 15.5858 0.5 15.5858H2.798C2.93035 15.5858 3.05729 15.5333 3.151 15.4398L12.599 5.99179L9.599 2.99179L0.147 12.4398C0.0531646 12.5333 0.000293383 12.6603 0 12.7928ZM10.837 1.75279L13.837 4.75279L15.297 3.29279C15.4845 3.10526 15.5898 2.85095 15.5898 2.58579C15.5898 2.32062 15.4845 2.06631 15.297 1.87879L13.712 0.292786C13.5245 0.105315 13.2702 0 13.005 0C12.7398 0 12.4855 0.105315 12.298 0.292786L10.837 1.75279Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconProfile);
export default __webpack_public_path__ + "static/media/edit_icon_profile.4f27dbf11e78956864c7dcedf8f12044.svg";
export { ForwardRef as ReactComponent };